import React, { useState } from "react";
import { Link } from "react-router-dom";
import portalApi from "@/lib/portalApi";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { marketingUrl } from "@/lib/marketingUrl";

export default function PortalLogin() {
    const [email, setEmail] = useState("");
    const [portalType, setPortalType] = useState("");
    const [sent, setSent] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await portalApi.post("/portal/request-link", {
                email,
                portal_type: portalType || undefined,
            });
            setSent(true);
            toast.success("If your email is registered, a sign-in link has been sent.");
        } catch (err) {
            toast.error("Unable to request link");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-background px-4">
            <div className="w-full max-w-md" data-testid="portal-login">
                <div className="mb-8 text-center">
                    <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-2">Stakeholder access</div>
                    <h1 className="text-3xl tracking-tight">Portal sign in</h1>
                    <p className="text-sm text-muted-foreground mt-2">
                        Enter the email address the project team invited. A one-time sign-in link expires in 15 minutes.
                    </p>
                </div>

                {!sent ? (
                    <form onSubmit={submit} className="space-y-4 border border-border p-6" data-testid="portal-login-form">
                        <div>
                            <label className="text-xs uppercase tracking-wide text-muted-foreground">Email</label>
                            <input
                                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                                className="mt-1 w-full border border-border bg-background px-3 py-2 text-sm"
                                data-testid="portal-login-email"
                            />
                        </div>
                        <div>
                            <label className="text-xs uppercase tracking-wide text-muted-foreground">Portal type (optional)</label>
                            <select value={portalType} onChange={(e) => setPortalType(e.target.value)}
                                className="mt-1 w-full border border-border bg-background px-3 py-2 text-sm"
                                data-testid="portal-login-type">
                                <option value="">Auto-detect</option>
                                <option value="client">Client</option>
                                <option value="investor">Investor</option>
                                <option value="lender">Lender</option>
                                <option value="subcontractor">Subcontractor</option>
                            </select>
                        </div>
                        <button disabled={busy} className="w-full bg-foreground text-background py-2 text-sm hover:opacity-90" data-testid="portal-login-submit">
                            {busy ? "Sending…" : "Send sign-in link"}
                        </button>
                        <p className="text-xs text-muted-foreground">
                            <a href={marketingUrl("/")} className="underline">Back to home</a>
                        </p>
                    </form>
                ) : (
                    <div className="border border-border p-6 text-center" data-testid="portal-login-sent">
                        <Mail size={24} className="mx-auto mb-3" />
                        <div className="text-sm">Check your email for a secure sign-in link.</div>
                        <div className="text-xs text-muted-foreground mt-2">The link expires in 15 minutes.</div>
                        <button onClick={() => setSent(false)} className="mt-4 text-xs underline">Send another</button>
                    </div>
                )}
            </div>
        </div>
    );
}
